import {Component, forwardRef, Injector} from "@angular/core";
import {ColumnComponent} from "../../../grid/column.component";
import {AbstractSingleSelectColumnComponent} from "./abstract-single-select-column.component";

/**
 * Provides a single selection edit column. <wbo-select-options> is used to provide the options.
 */
@Component({
    selector: "wbo-single-select-column",
    styleUrls: ["./single-select-column.component.scss"],
    templateUrl: "./single-select-column.component.html",
    providers: [
        {provide: ColumnComponent, useExisting: forwardRef(() => SingleSelectColumnComponent), multi: true}
    ]
})
export class SingleSelectColumnComponent extends AbstractSingleSelectColumnComponent {
    constructor(injector: Injector) {
        super(injector);
    }
}
